import * as React from 'react';
import { MutableRefObject } from 'react';

import { ExternalLinkProps } from 'shared/entities/components/ExternalLink';

const ExternalLink = React.forwardRef(
  (
    {
      children,
      rel = 'noreferrer noopener',
      target = '_blank',
      className,
      ...rest
    }: ExternalLinkProps,
    ref: MutableRefObject<HTMLAnchorElement>
  ) => {
    return (
      <a ref={ref} {...rest} rel={rel} target={target} className={className}>
        {children}
      </a>
    );
  }
);

export default React.memo(ExternalLink);
